<div class="invoice-card-container">
    
    <!-- Header Section -->
    <div class="flex items-center justify-between mb-6">
        <div>
            <h2 class="text-xl font-bold text-gray-900 dark:text-white">Lista przychodów</h2>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Twoje faktury sprzedażowe</p>
        </div>
        <!-- <button mat-button class="!rounded-xl" [matMenuTriggerFor]="optionMenu">
            <mat-icon [svgIcon]="'tabler_outline:adjustments-horizontal'" class="mr-1 h-4 w-4"></mat-icon>
            {{selectedFieldId.text}}
            <mat-icon [svgIcon]="'tabler_outline:chevron-down'" class="ml-1 h-4 w-4"></mat-icon>
        </button> -->
        <!-- <mat-menu #optionMenu="matMenu">
            <button *ngFor="let field of countFieldOptions" mat-menu-item (click)="changeOption(field)">
                <mat-icon [svgIcon]="field.value == selectedFieldId.value ? 'tabler_outline:check' : 'tabler_outline:coin'" class="h-4 w-4"></mat-icon>
                {{field.text}}
            </button>
        </mat-menu> -->
    </div>

    <!-- Month Cards -->
    <div class="space-y-4">
        <ng-container *ngFor="let element of visibleData; let i = index;">
            
            <!-- Current Month (Featured) -->
            <div *ngIf="i === 0" class="featured-month-card overflow-hidden rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700">
                
                <!-- Featured Header -->
                <div class="featured-header bg-gradient-to-r from-blue-600 via-blue-500 to-cyan-500 p-5">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-3">
                            <div class="h-12 w-12 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                                <mat-icon [svgIcon]="'tabler_outline:calendar-stats'" class="text-white h-6 w-6"></mat-icon>
                            </div>
                            <div>
                                <div class="text-white/80 text-sm">Bieżący miesiąc</div>
                                <div class="text-white text-xl font-bold capitalize">{{element.monthName}} {{element.year}}</div>
                            </div>
                        </div>
                        <div class="text-right">
                            <div *ngFor="let sum of element.summary" class="text-white">
                                <span class="text-2xl font-bold">{{sum.summary > 0 ? toDecimal(sum.summary) : '0,00'}}</span>
                                <span class="text-white/70 text-sm ml-1">{{sum.currency}}</span>
                            </div>
                            <span *ngIf="element?.summary?.length == 0" class="text-white/70 text-sm">Brak danych</span>
                        </div>
                    </div>
                </div>

                <!-- Documents List -->
                <div class="bg-card" *ngIf="element.documents.length > 0">
                    <div class="documents-header grid grid-cols-12 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide px-5 py-3 bg-gray-50 dark:bg-slate-800/50 border-b border-gray-100 dark:border-slate-700">
                        <div class="col-span-1"></div>
                        <div class="col-span-6">Kontrahent / Dokument</div>
                        <div class="col-span-5 text-end">{{selectedFieldId.text}}</div>
                    </div>
                    
                    <div *ngFor="let document of element.documents; let last = last"
                        [routerLink]="'/konto/dokumenty/' + document._id + '/podglad'"
                        class="document-row grid grid-cols-12 items-center gap-3 px-5 py-4 cursor-pointer hover:bg-blue-50/50 dark:hover:bg-slate-800/50 transition-colors duration-200"
                        [class.border-b]="!last"
                        [class.border-gray-100]="!last"
                        [class.dark:border-slate-700]="!last">
                        
                        <div class="col-span-1">
                            <direction-badge [document]="document" [size]="'sm'"></direction-badge>
                        </div>
                        
                        <div class="col-span-6">
                            <div class="font-medium text-gray-900 dark:text-white truncate">{{getBuyerName(document)}}</div>
                            <div class="flex items-center gap-2 mt-1">
                                <span class="text-sm text-gray-500 dark:text-gray-400">{{document.invoiceName || document.documentNumber}}</span>
                                <mat-icon *ngIf="document.ksefReferenceNumber" 
                                    class="h-5 w-5 rounded-md" 
                                    matTooltip="Wysłano do KSeF" 
                                    [svgIcon]="'ksef:ksef-logo'"></mat-icon>
                            </div>
                            <div class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">{{getDocumentTypeName(document)}}</div>
                        </div>
                        
                        <div class="col-span-5 text-end">
                            <span class="text-lg font-semibold text-gray-900 dark:text-white">{{getDocumentValue(document) | number:'1.2-2'}}</span>
                            <span class="text-sm text-gray-400 dark:text-gray-500 ml-1">{{getDocumentCurrency(document)}}</span>
                        </div>
                    </div>
                </div>
                
                <div *ngIf="element.documents.length === 0" class="p-8 text-center text-gray-400">
                    <mat-icon [svgIcon]="'tabler_outline:file-off'" class="h-12 w-12 mx-auto mb-2 opacity-50"></mat-icon>
                    <p>Brak dokumentów w tym miesiącu</p>
                </div>
            </div>

            <!-- Previous Months (Collapsible) -->
            <div *ngIf="i > 0 && element.documents.length > 0" 
                class="month-card overflow-hidden rounded-2xl border border-gray-100 dark:border-slate-700 bg-card">
                
                <!-- Collapsible Header -->
                <div (click)="element.toggleExpand()" 
                    class="month-header flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-800/50 transition-colors duration-200"
                    [matTooltip]="element.expanded ? 'Kliknij, aby zwinąć' : 'Kliknij, aby rozwinąć'">
                    <div class="flex items-center gap-3">
                        <div class="h-10 w-10 rounded-xl bg-gray-100 dark:bg-slate-700 flex items-center justify-center">
                            <mat-icon [svgIcon]="'tabler_outline:calendar'" class="h-5 w-5 text-gray-500 dark:text-gray-400"></mat-icon>
                        </div>
                        <div>
                            <div class="font-semibold text-gray-900 dark:text-white capitalize">{{element.monthName}} {{element.year}}</div>
                            <div class="text-sm text-gray-500 dark:text-gray-400">{{element.documents.length}} dokumentów</div>
                        </div>
                    </div>
                    <div class="flex items-center gap-3">
                        <div class="text-right">
                            <div *ngFor="let sum of element.summary">
                                <span class="text-lg font-semibold text-gray-900 dark:text-white">{{toDecimal(sum.summary)}}</span>
                                <span class="text-sm text-gray-400 dark:text-gray-500 ml-1">{{sum.currency}}</span>
                            </div>
                        </div>
                        <mat-icon [svgIcon]="element.expanded ? 'tabler_outline:chevron-up' : 'tabler_outline:chevron-down'" 
                            class="h-5 w-5 text-gray-400 transition-transform duration-200"></mat-icon>
                    </div>
                </div>

                <!-- Expanded Content -->
                <ng-container *ngIf="element.expanded">
                    <div class="documents-header grid grid-cols-12 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide px-5 py-3 bg-gray-50 dark:bg-slate-800/50 border-t border-b border-gray-100 dark:border-slate-700">
                        <div class="col-span-1"></div>
                        <div class="col-span-6">Kontrahent / Dokument</div>
                        <div class="col-span-5 text-end">{{selectedFieldId.text}}</div>
                    </div>
                    
                    <div *ngFor="let document of element.documents; let last = last"
                        [routerLink]="'/konto/dokumenty/' + document._id + '/podglad'"
                        class="document-row grid grid-cols-12 items-center gap-3 px-5 py-4 cursor-pointer hover:bg-blue-50/50 dark:hover:bg-slate-800/50 transition-colors duration-200"
                        [class.border-b]="!last"
                        [class.border-gray-100]="!last"
                        [class.dark:border-slate-700]="!last">
                        
                        <div class="col-span-1">
                            <direction-badge [document]="document" [size]="'sm'"></direction-badge>
                        </div>
                        
                        <div class="col-span-6">
                            <div class="font-medium text-gray-900 dark:text-white truncate">{{getBuyerName(document)}}</div>
                            <div class="flex items-center gap-2 mt-1">
                                <span class="text-sm text-gray-500 dark:text-gray-400">{{document.invoiceName || document.documentNumber}}</span>
                                <mat-icon *ngIf="document.ksefReferenceNumber" 
                                    class="h-5 w-5 p-0.5 rounded-md bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600" 
                                    matTooltip="Wysłano do KSeF" 
                                    [svgIcon]="'ksef:ksef-logo'"></mat-icon>
                            </div>
                            <div class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">{{getDocumentTypeName(document)}}</div>
                        </div>
                        
                        <div class="col-span-5 text-end">
                            <span class="text-lg font-semibold text-gray-900 dark:text-white">{{getDocumentValue(document) | number:'1.2-2'}}</span>
                            <span class="text-sm text-gray-400 dark:text-gray-500 ml-1">{{getDocumentCurrency(document)}}</span>
                        </div>
                    </div>
                </ng-container>
            </div>

        </ng-container>
    </div>

    <!-- Load More Button -->
    <div class="text-center mt-6" [style.visibility]="hasMoreRecords ? 'visible' : 'hidden'">
        <button (click)="loadMore()" mat-stroked-button class="!rounded-xl !px-8">
            <mat-icon [svgIcon]="'tabler_outline:refresh'" class="mr-2 h-4 w-4"></mat-icon>
            Pokaż więcej
        </button>
    </div>

</div>